/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbStatutSocialGridDto } from './FcbStatutSocialGridDto';
import {
    FcbStatutSocialGridDtoFromJSON,
    FcbStatutSocialGridDtoFromJSONTyped,
    FcbStatutSocialGridDtoToJSON,
} from './FcbStatutSocialGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbStatutSocialGridDtoPaginatedResults
 */
export interface FcbStatutSocialGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbStatutSocialGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbStatutSocialGridDto>}
     * @memberof FcbStatutSocialGridDtoPaginatedResults
     */
    results?: Array<FcbStatutSocialGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbStatutSocialGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbStatutSocialGridDtoPaginatedResults interface.
 */
export function instanceOfFcbStatutSocialGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbStatutSocialGridDtoPaginatedResultsFromJSON(json: any): FcbStatutSocialGridDtoPaginatedResults {
    return FcbStatutSocialGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbStatutSocialGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbStatutSocialGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbStatutSocialGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbStatutSocialGridDtoPaginatedResultsToJSON(value?: FcbStatutSocialGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbStatutSocialGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

